// --- Our Modules --------------------------------------------------------------------------------
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
type Props = {
    label: string;
    /** Decides the colour only. A unit's status, a project's stage, an offer — each has its own set. */
    tone?: "available" | "reserved" | "sold" | "rented" | "neutral" | "accent" | "danger";
    size?: "sm" | "md";
};

/**
 * A derived value, shown. **Never an editable control** — a chip that can be clicked to change what it
 * reports stops being a report. Editing a status happens in the form, where the rule that guards it
 * can explain itself.
 */
export default function StatusChip({ label, tone = "neutral", size = "md" }: Props) {
    return <span className={`status-chip status-chip--${tone} status-chip--${size}`}>{label}</span>;
}
